/**
 * @description: 商品套餐销售明细报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="gsr-stxm-report">
        <div class="stxm-list">
            <p class="p-hint">注：当天营业数据就只能单个营业日，历史数据支持一个月内的数据查询</p>
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="stxmTime">
                        <input type="text" class="form-control laydate-icon" v-model="stxmStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="stxmEndTime">
                    </div>
                </div>
                <label class="list-label-4">消费门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="stxm_shop" data-placeholder="请选择消费门店"></select>
                </div>
                <label class="list-label-4">包厢区域:</label>
                <div class="col-md-2">
                    <input class="form-control input-readonly" placeholder="请选择包厢区域" v-model="stxm_room_area" ref="stxm_room_area" readonly @click="stxmRoomAreaFun()">
                    <span class="selection-clear" @click="clear_input">×</span>
                    <span class="span-arrow" role="presentation"><b></b></span>
                </div>
                <label class="list-label-3">操作人:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="stxm_admin" data-placeholder="请选择操作人"></select>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-4">支付类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="stxm_pay_type" data-placeholder="请选择支付类型">
                    </select>
                </div>
                <label class="list-label-6">商品套餐类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="stxm_goods_package" data-placeholder="请选择商品套餐类型">
                        <option value="0">全部</option>
                    </select>
                </div>
                <label class="list-label-6">商品套餐名称:</label>
                <div class="col-md-2">
                    <input type="text" class="form-control" v-model="stxm_name" placeholder="请输入商品套餐名称">
                </div>
                <label class="list-label-4">导购员工:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="stxm_staff" data-placeholder="请选择导购员工"></select>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-4">会员卡号:</label>
                <div class="col-md-2">
                    <input class="form-control" placeholder="请输入会员卡号" v-model="stxm_vip_card">
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitStxmTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getStxmExportSet">导出</button>
                </div>
            </div>
            <div class="row">
                <label class="list-label-6">销售数据合计:</label>
                <div class="list-total" ref="stxm_xs_total"></div>
                <label class="list-label-6">折后总额合计:</label>
                <div class="list-total" ref="stxm_zh_total"></div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="stxmList"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="stxmExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='stxmExport_allcheck' @click='stxmExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='stxmExport_checkModel' value="time">
                            <label>支付时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='stxmExport_checkModel' value="order_id">
                            <label>订单编号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='stxmExport_checkModel' value="pay_platform">
                            <label>支付类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='stxmExport_checkModel' value="vip_card">
                            <label>会员卡号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='stxmExport_checkModel' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='stxmExport_checkModel' value="room_area_name">
                            <label>包厢区域</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='stxmExport_checkModel' value="room_name">
                            <label>包厢号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='stxmExport_checkModel' value="admin_name">
                            <label>操作人</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='stxmExport_checkModel' value="wares_type_name">
                            <label>商品套餐类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='stxmExport_checkModel' value="wares_name">
                            <label>商品套餐名称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='stxmExport_checkModel' value="goods_unit_name">
                            <label>单位</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='stxmExport_checkModel' value="shopping_name">
                            <label>导购员工</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='stxmExport_checkModel' value="quantity">
                            <label>销售数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='stxmExport_checkModel' value="refund_quantity">
                            <label>退货数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='stxmExport_checkModel' value="actual_pay">
                            <label>折后单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='stxmExport_checkModel' value="actual_pay_total">
                            <label>折后总额</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='stxmExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='stxmExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 包厢区域弹窗 -->
            <div class="ele-hide" ref="stxm_area_alert">
                <div class="sel-seldiv">
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='stxm_area_allcheck' @click='stxmAreaCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li v-for="item in stxm_area_data" :key="item.id">
                            <input type="checkbox" v-model='stxm_area_model' :value="item.id">
                            <label>{{item.name}}</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                stxmStartTime: "",
                stxmEndTime: "",
                stxm_room_area: '',
                stxm_name: '',
                stxm_vip_card: '',
                stxm_area_allcheck: false,
                stxm_c_area_allcheck: false,
                stxm_area_model: [],
                stxm_area_data: [],
                stxmExport_allcheck: false,
                c_stxmExport_allcheck: false,
                stxmExport_checkModel: [],
                stxmExport_checkData: ['time', 'order_id', 'pay_platform', 'vip_card', 'shop_name', 'room_area_name', 'room_name', 'admin_name', 'wares_type_name', 'wares_name', 'goods_unit_name', 'shopping_name', 'quantity', 'refund_quantity', 'actual_pay', 'actual_pay_total'],
                stxmExport_type: 1,
            }
        },
        watch: {
            stxm_room_area: {
                handler: function(val, oldval) {
                    if(val != "") {
                        $(this.$refs.stxm_room_area).parent().find('.selection-clear').show();
                    } else {
                        $(this.$refs.stxm_room_area).parent().find('.selection-clear').hide();
                    }
                },
                deep: true
            },
            stxm_area_model: {
                handler: function(val, oldVal) {
                    if(this.stxm_area_model.length >= this.stxm_area_data.length) {
                        this.stxm_area_allcheck = true;
                        this.stxm_c_area_allcheck = true;
                    } else {
                        this.stxm_area_allcheck = false;
                        this.stxm_c_area_allcheck = false;
                    }
                },
                deep: true
            },
            stxmExport_checkModel: {
                handler: function(val, oldVal) {
                    if(this.stxmExport_checkModel.length >= this.stxmExport_checkData.length) {
                        this.stxmExport_allcheck = true;
                        this.c_stxmExport_allcheck = true;
                    } else {
                        this.stxmExport_allcheck = false;
                        this.c_stxmExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.stxmStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.stxmEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.innitDate(); // 日期
            this.shopDatas = [];
            this.innitInput();  // 门店
            this.getGoodsPackageType(); // 商品套餐类型
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.stxmStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.stxmEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.stxmStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.stxmEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.stxmTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.stxmStartTime = start.format('YYYY-MM-DD HH:mm');
                    _this.stxmEndTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.stxm_shop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                _this.getPaytype(e.params.data.id);
                                // 操作人
                                _this.getAdmin(e.params.data.id);
                                if(e.params.data.text == "全部") {
                                    $(_this.$refs.stxm_room_area).val('').trigger('change');
                                    $(_this.$refs.stxm_room_area).prop('disabled', true);
                                    $(_this.$refs.stxm_staff).val('').trigger('change');
                                    $(_this.$refs.stxm_staff).prop('disabled', true);
                                    return;
                                }
                                $(_this.$refs.stxm_room_area).val('').trigger('change');
                                $(_this.$refs.stxm_room_area).prop('disabled', false);
                                _this.getRoomArea(e.params.data.id);
                                $(_this.$refs.stxm_staff).val('').trigger('change');
                                $(_this.$refs.stxm_staff).prop('disabled', false);
                                _this.getOrderStaff(e.params.data.id);
                                _this.setShopDefaultTime(e.params.data.id);
                            });
                            $(_this.$refs.stxm_shop).val(data.response.result[1].id).trigger('change');
                            $(_this.$refs.stxm_room_area).val('').trigger('change');
                            $(_this.$refs.stxm_room_area).prop('disabled', false);
                            _this.getRoomArea($(_this.$refs.stxm_shop).val());
                            _this.getPaytype($(_this.$refs.stxm_shop).val());
                            $(_this.$refs.stxm_staff).val('').trigger('change');
                            $(_this.$refs.stxm_staff).prop('disabled', false);
                            _this.getOrderStaff($(_this.$refs.stxm_shop).val());
                            // 操作人
                            _this.getAdmin($(_this.$refs.stxm_shop).val());
                            _this.setShopDefaultTime($(_this.$refs.stxm_shop).val());
                            _this.innitStxmTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取包厢区域
            getRoomArea: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getRoomArea",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.stxm_area_data = data.response.result;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取操作人
            getAdmin: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "User/getList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result']['user_info'], function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.stxm_admin).html("");
                            $(_this.$refs.stxm_admin).select2({
                                data: arr,
                                language: "zh-CN",
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取支付类型
            getPaytype: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Order/getAllPayPlatform",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{id: '0', text: '全部'}];
                            for(let [key, value] of Object.entries(data.response.data)) {
                                arr.push({id: key, text: value});
                            }
                            $(_this.$refs.stxm_pay_type).html("");
                            $(_this.$refs.stxm_pay_type).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: "100%"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取商品套餐类型
			getGoodsPackageType() {
				const _this = this;
				Vue.axios.post('PublicData/api_getWaresType', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
                        let arr = []
						$.each(res.data.response.result.data, function(k, v) {
							arr.push({ id: v.id, text: v.name });
						});
						$(_this.$refs.stxm_goods_package).select2({
							data: arr,
							width: '100%'
						});
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
            // 获取导购员工
            getOrderStaff: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id,
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "user/getSearchList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: " ", text: '全部' }];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.stxm_staff).html("");
                            $(_this.$refs.stxm_staff).select2({
                                data: arr,
                                language: "zh-CN",
                                minimumResultsForSearch: -1,
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 清空多选
            clear_input: function() {
                this.stxm_room_area = "";
                this.stxm_area_model = [];
            },



            // 打开包厢区域
            stxmRoomAreaFun: function() {
                let _this = this;
                let stxm_c_area_model = _this.stxm_area_model;
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['包厢区域', true],
                    area: ['300px', ''], // 宽高
                    content: $(_this.$refs.stxm_area_alert),
                    cancel: function() {
                        // 右上角关闭
                        if(_this.stxm_room_area != "") {
                            _this.stxm_area_model = stxm_c_area_model;
                            return;
                        }
                        _this.stxm_room_area = [];
                    }
                }, function() {
                    let areaTxts = [];
                    _this.stxm_area_data.forEach(function(item) {
                        _this.stxm_area_model.forEach(function(item2) {
                            if(item.id == item2) {
                                areaTxts.push(item.name);
                            }
                        });
                    });
                    _this.stxm_room_area = areaTxts.join(",");
                    layer.closeAll();
                }, function() {
                    if(_this.stxm_room_area != "") {
                        _this.stxm_area_model = stxm_c_area_model;
                        return;
                    }
                    _this.stxm_area_model = [];
                });
            },
            // 包厢区域全选
            stxmAreaCheckedAll: function() {
                let _this = this;
                _this.stxm_area_allcheck = _this.stxm_c_area_allcheck;
                if(!_this.stxm_area_allcheck) { // 实现全选
                    _this.stxm_area_model = [];
                    _this.stxm_area_data.forEach(function(item) {
                        _this.stxm_area_model.push(item.id);
                    });
                } else { // 实现反选
                    _this.stxm_area_model = [];
                }
            },
            // 表格
            innitStxmTable: function() {
                let _this = this;
                $(_this.$refs.stxmList).bootstrapTable('destroy');
                $(_this.$refs.stxmList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getStxmList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "time",
                        title: "支付时间",
                        width: "100",
                        valign: "middle"
                    }, {
                        field: "order_id",
                        title: "订单编号",
                        width: "110",
                        valign: "middle"
                    }, {
                        field: "pay_platform",
                        title: "支付类型",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "vip_card",
                        title: "会员卡号",
                        width: "7%",
                        valign: "middle"
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "130",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return value.length > '14' ? value.slice(0, 14) + '...' : value
                        }
                    }, {
                        field: "room_area_name",
                        title: "包厢区域",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "room_name",
                        title: "包厢号",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "admin_name",
                        title: "操作人",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "wares_type_name",
                        title: "商品套餐<br />类型",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "wares_name",
                        title: "商品套餐<br />名称",
                        width: "130",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return value.length > '14' ? value.slice(0, 14) + '...' : value
                        }
                    }, {
                        field: "goods_unit_name",
                        title: "单位",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "shopping_name",
                        title: "导购员工",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "quantity",
                        title: "销售数量",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "refund_quantity",
                        title: "退货数量",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "actual_pay",
                        title: "折后单价",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "actual_pay_total",
                        title: "折后总额",
                        width: "6%",
                        valign: "middle"
                    }],
                });
            },
            getStxmList: function(params) {
                let _this = this,
                    pageNumber = 1,
                    area_ids = '';
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                if(_this.stxm_area_model != '' && !_this.stxm_area_allcheck) {
                    area_ids = _this.stxm_area_model.join(',');
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_date": _this.stxmStartTime,
                            "end_date": _this.stxmEndTime,
                            "shop_id": $(_this.$refs.stxm_shop).val(),
                            "area_ids": area_ids,
                            "pay_platform": $(_this.$refs.stxm_pay_type).val(),
                            "ware_goods_type": $(_this.$refs.stxm_goods_package).val(),
                            "wares_name": _this.stxm_name,
                            "admin_id": $.trim($(_this.$refs.stxm_admin).val()),
                            "shopping_guide": $.trim($(_this.$refs.stxm_staff).val()),
                            "vip_card": _this.stxm_vip_card,
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + 'FinanceReport2/getSaleWaresList',
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.data
                            });
                            $(_this.$refs.stxm_xs_total).text(data.response.result.quantity_total);
                            $(_this.$refs.stxm_zh_total).text(data.response.result.actual_pay_total);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getStxmExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport2/getSaleWaresExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.stxmExport_checkModel = data.response.result.export_fields;
                                _this.stxmExport_type = data.response.result.export_type;
                            } else {
                                _this.stxmExport_checkModel = _this.stxmExport_checkData;
                                _this.stxmExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.stxmExport_alert)
                }, function() {
                    _this.exportStxmList();
                });
            },
            // 导出字段全选
            stxmExportCheckedAll: function(type) {
                let _this = this;
                _this.stxmExport_allcheck = _this.c_stxmExport_allcheck;
                if(!_this.stxmExport_allcheck) { // 实现全选
                    _this.stxmExport_checkModel = [];
                    _this.stxmExport_checkData.forEach(function(item) {
                        _this.stxmExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.stxmExport_checkModel = [];
                }
            },
            // 点击“导出”按钮
            exportStxmList: function() {
                let _this = this,
                    area_ids = '';

                let export_fields = JSON.stringify(_this.stxmExport_checkModel);
                if(_this.stxm_area_model != '' && !_this.stxm_area_allcheck) {
                    area_ids = _this.stxm_area_model.join(',');
                }
                window.location.href = Vue.ctUrl + "FinanceReport2/getSaleWaresExport" +
                    "?start_date=" + _this.stxmStartTime +
                    "&end_date=" + _this.stxmEndTime +
                    "&shop_id=" + $(_this.$refs.stxm_shop).val() +
                    "&area_ids=" + area_ids +
                    "&pay_platform=" + $(_this.$refs.stxm_pay_type).val() +
                    "&ware_goods_type=" + $(_this.$refs.stxm_goods_package).val() +
                    "&wares_name=" + _this.stxm_name +
                    "&admin_id=" + $.trim($(_this.$refs.stxm_admin).val()) +
                    "&shopping_guide=" + $.trim($(_this.$refs.stxm_staff).val()) +
                    "&vip_card=" + _this.stxm_vip_card +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.stxmExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    .stxm-list {
        .fixed-table-body {
            overflow-x: scroll;
            table {
                width: 1700px;
                // table-layout: fixed;
                word-wrap: break-word;
            }
        }
        .fixed-table-body::-webkit-scrollbar {
            position: absolute;
            top: 0;
            left: 0;
            height: 30px;
        }
    }
</style>